'use strict';

var ServiceTypes = require('../constants/ServiceTypes');

var getServiceName = function(serviceType) {
  switch (serviceType) {
  case ServiceTypes.FACEBOOK:
    return 'Facebook';
  case ServiceTypes.TWITTER:
    return 'Twitter';
  case ServiceTypes.GOOGLE:
    return 'Google';
  case ServiceTypes.TUMBLR:
    return 'Tumblr';
  case ServiceTypes.INSTAGRAM:
    return 'Instagram';
  }
};

module.exports = getServiceName;


/** WEBPACK FOOTER **
 ** ./utils/getServiceName.js
 **/